// npcs.js — ホールにいる人たちと、その台詞（純粋モジュール / ブラウザAPI非依存）
//
// 台詞そのものは言語ごとに変わるので js/locales/ にある。ここが持つのは
// 「誰がどの束から喋るか」と、日付から決まる運勢の組み立てだけ。

import { MACHINES, machineShort } from './machines.js';
import { t, tList, tPick } from './i18n.js';

// 日付から決まる値を作るための単純なハッシュ。
// 同じ日なら何度話しかけても同じ結果になり、日付が変われば変わる。
export function hashString(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

// 色と方角は「何番目か」だけを決めて、名前は言語側から引く
const LUCKY_CSS = ['#ff4d5e', '#ffd166', '#4de0ff', '#5cdb95',
  '#c77dff', '#f0f4ff', '#ffb454', '#ff8ad4'];
const DIR_COUNT = 8;
const RANK_COUNT = 5;

/** その日の運勢。dateKey は 'YYYY-MM-DD' を想定 */
export function fortuneOf(dateKey) {
  const h = hashString(dateKey);
  const colorIdx = (h >>> 3) % LUCKY_CSS.length;
  return {
    rank: t(`fortune.rank.${h % RANK_COUNT}`),
    color: { name: t(`fortune.color.${colorIdx}`), css: LUCKY_CSS[colorIdx] },
    dir: t(`fortune.dir.${(h >>> 7) % DIR_COUNT}`),
    machine: MACHINES[(h >>> 11) % MACHINES.length],
    seat: ((h >>> 17) % 88) + 1,
  };
}

/**
 * NPC の定義。並び順が areas.js の記号 'a','b','c','d' に対応する
 * （配置はマップ側が持つ。ここに座標を持たせると二重管理になる）。
 * talk(ctx) は表示する行の配列を返す。ctx = { dateKey, rng }
 */
export const NPCS = [
  {
    id: 'clerk',
    color: '#ffd166',
    body: '#e05a6a',
    // 店員だけは何行かまとめて喋るので、束の中から 1 本を選ぶ
    talk: ({ rng }) => tPick('npc.clerk.lines', rng),
  },
  {
    id: 'regular',
    color: '#8fd8ff',
    body: '#3d5a9e',
    talk: ({ rng }) => tPick('npc.regular.lines', rng),
  },
  {
    id: 'fortune',
    color: '#c77dff',
    body: '#6b3fa0',
    talk: ({ dateKey }) => {
      const f = fortuneOf(dateKey);
      return tList('npc.fortune.lines').map((line) => line
        .split('{rank}').join(f.rank)
        .split('{color}').join(f.color.name)
        .split('{dir}').join(f.dir)
        .split('{machine}').join(machineShort(f.machine))
        .split('{seat}').join(f.seat));
    },
    fortune: true,
  },
  {
    id: 'gag',
    color: '#ffb454',
    body: '#a8452f',
    talk: ({ rng }) => tPick('npc.gag.lines', rng),
  },
];

export const npcName = (npc) => t(`npc.${npc.id}.name`);

export function todayKey(d) {
  const dt = d || new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${dt.getFullYear()}-${p(dt.getMonth() + 1)}-${p(dt.getDate())}`;
}
